import BaseAPI from './base'

class TeacherRankingAPI extends BaseAPI {}

export default new TeacherRankingAPI('v1/teacher-ranking', 'TeacherRanking')
